import Cookies from 'js-cookie'
import axios from 'axios'
// import jwtDecode from 'jwt-decode'
import Vue from 'vue'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import App from './App.vue'
import router from './router'
import store from './store'
import {getResponseError} from "@/components/utils";

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.state.auth.isLoggedIn) {
            next()
        } else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        }
    } else {
        next()
    }
})

let http = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/api/',
    headers: {
        'X-CSRFToken': Cookies.get('csrftoken')
    }
})

http.interceptors.request.use(function (config) {
        config.headers.Authorization = 'JWT ' + store.getters['auth/token']

        if (store.getters['auth/isExpired']()) {
            return new Promise((resolve, reject) => {
                store.dispatch('auth/refresh')
                    .then(() => {
                        config.headers.Authorization = 'JWT ' + store.getters['auth/token']
                        resolve(config)
                    })
                    .catch((e) => {
                        store.dispatch('auth/logout')
                        reject(getResponseError(e))
                    })
            })
        } else {
            return config
        }
    },
    function (error) {
        return Promise.reject(error)
    }
)
// Add a response interceptor
http.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 400) {
        let errors = error.response.data
        for (let [field, err] of Object.entries(errors)) {
            store.dispatch('snackbar/warning', `${field} validation error: ${err[0]}`)
        }
    }
    return Promise.reject(error)
})
// http.interceptors.response.use(
//     (response) => {
//         return response
//     },
//     (error) => {
//         window.console.log('Response Intercepted')
//         // Check if it is Auth error
//         if (!([401, 403].includes(error.response.status))) {
//             window.console.log('Not Auth related')
//             return new Promise((resolve, reject) => {
//                 reject(error);
//             })
//         }
//         window.console.log('Not Auth related')
//         // Refresh Token if it is expired
//         if (store.getters['auth/isExpired']) {
//             window.console.log('Access Token Expired')
//             return new Promise((resolve, reject) => {
//                 store.dispatch('auth/refresh')
//                     .then(() => {
//                         const config = error.config;
//                         config.headers.Authorization = 'JWT ' + store.getters['auth/token']
//
//                         return new Promise((resolve, reject) => {
//                             http.request(config).then(response => {
//                                 resolve(response)
//                             }).catch((error) => {
//                                 reject(error)
//                             })
//                         })
//                     })
//                     .catch(() => {
//                         store.dispatch('auth/logout')
//                         reject(new Error('Authentication error'))
//                     })
//             })
//         }
//     }
// )

Vue.prototype.$axios = http


new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
